import styled from "styled-components";

export const MainContainer = styled.main.attrs({ className: "MainContainer" })`
  display: flex;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
`;

export const PageContentContainer = styled.main.attrs({ className: "PageContentContainer" })`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  padding: 1.5rem;
  background-color: transparent;
`;
